var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3476_1349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16669 15.0003H10.8334V13.3337H9.16669V15.0003ZM10 1.66699C5.40002 1.66699 1.66669 5.40033 1.66669 10.0003C1.66669 14.6003 5.40002 18.3337 10 18.3337C14.6 18.3337 18.3334 14.6003 18.3334 10.0003C18.3334 5.40033 14.6 1.66699 10 1.66699ZM10 16.667C6.32502 16.667 3.33335 13.6753 3.33335 10.0003C3.33335 6.32533 6.32502 3.33366 10 3.33366C13.675 3.33366 16.6667 6.32533 16.6667 10.0003C16.6667 13.6753 13.675 16.667 10 16.667ZM10 5.00033C8.15835 5.00033 6.66669 6.49199 6.66669 8.33366H8.33335C8.33335 7.41699 9.08335 6.66699 10 6.66699C10.9167 6.66699 11.6667 7.41699 11.6667 8.33366C11.6667 10.0003 9.16669 9.79199 9.16669 12.5003H10.8334C10.8334 10.6253 13.3334 10.417 13.3334 8.33366C13.3334 6.49199 11.8417 5.00033 10 5.00033Z",
    fill: "#927DFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3476_1349"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.179619c4662e109d658708ad0697a57c.svg";
export { ForwardRef as ReactComponent };